import { Errors } from './types';
import { BE_TURNSTILE_TOKEN_NAME } from './constants';

export const captchaValidations = (errors: Errors) => ({
  [BE_TURNSTILE_TOKEN_NAME]: {
    name: BE_TURNSTILE_TOKEN_NAME,
    type: 'hidden',
    dataTest: 'login-form-captcha-input',
    hasError: !!errors[BE_TURNSTILE_TOKEN_NAME],
    errorMessage: errors[BE_TURNSTILE_TOKEN_NAME]?.message,
    fullBorder: true,
    label: undefined,
    rules: {
      /**
       * We should disable the turnstile captcha validation based on the feature flag, however,
       * this is not possible due to lack of access to the feature flags state in the login page.
       * Thus, we are commenting this logic to allow failed captcha logins to be submitted to the BE.
       */
    },
  },
});
